import React, { useState } from 'react';
import Modal from 'react-modal';
import { useDispatch, useSelector } from 'react-redux';
import { DataGrid, esES } from '@mui/x-data-grid';
import { CustomToolbar } from '../../helpers/customtoolbar';
import { uiCloseModalOrdersOrDeliverys } from '../../actions/uiOrderOrDeliverys';
import { BtnDownload } from '../ui/BtnDownload';
import { PdfPreviewModal } from './PdfPreviewModal';
import './modal.css';

<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.bundle.min.js" integrity="sha384-ka7Sk0Gln4gmtz2MlQnikT1wXgYsOg+OMhuP+IlRH9sENBO0LRn5q+8nbTov4+1p" crossorigin="anonymous"></script>
Modal.setAppElement('#root');

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        maxHeight: '60vh',
        overflow: 'auto',
        width: '60%',
    },
};

export const OrdersDeliverysListModal = () => {

    const [pageSize, setPageSize] = useState(10);
    const {modalOpenOrdersOrDeliverys, modalData} = useSelector(state => state.uiOrdersOrDeliverys);
    const {listDOrO} = useSelector(state => state.delivery);
    const isDelivery = modalData?.type === 'deliverys';
    const dispatch = useDispatch();

    const columns = [
        {
            headerName: isDelivery ? 'ALBARANES' : 'PEDIDOS',
            field: isDelivery ? 'deliverynote' : 'ordercode',
            flex: 1,
        },
        {
            headerName: 'Acción',
            field: 'action',
            flex: 1,
            renderCell: (record) => (
                <BtnDownload  delivery= { record.row}/>
            ),
        },
    ];

    const closeModal = () => {
        dispatch(uiCloseModalOrdersOrDeliverys());
    }

    return (
        <Modal
            isOpen={modalOpenOrdersOrDeliverys}
            onRequestClose={closeModal}
            style={customStyles}
            closeTimeoutMS={200}
            className="modal modal-list-exp"
            overlayClassName="modal-fondo"
        >
            <h1 className='title'>{isDelivery ? "Albaranes disponibles" : "Pedidos disponibles"}</h1>
            <hr/>

            <div className='table-container'>
                <div className="table-style-stock margin-top">
                    <DataGrid
                        rows={listDOrO || [] }
                        columns={columns}
                        getRowId={(row) => `${row.number}-${Math.random().toString(36).substr(2, 9)}`}
                        pageSize={pageSize}
                        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                        rowsPerPageOptions={[10, 20, 30]}
                        pagination
                        localeText={esES.components.MuiDataGrid.defaultProps.localeText}
                        components={{Toolbar: CustomToolbar}}
                    />
                </div>
            </div>
            <div className="row justify-content-end mt-3">
                <div className="col-12 d-grid gap-2">
                    <button className="btn btn-outline-danger" onClick={closeModal}>
                        Cerrar
                    </button>
                </div>
            </div>
            <PdfPreviewModal/>
        </Modal>
    );
};